export const AccountCacheKey = {
    ACCESS_TOKEN: 'CACHE_ACCESS_TOKEN',
    SESSION_USER: 'CACHE_SESSION_USER',
};